import { snippetNodeId } from '@/features/source-snippets/object-set'
import type { GraphView } from '@/types/graph-view'

/** Add members once; source rows stay inside their snapshot, never as Neo4j nodes. */
export function mergeObjectSet(base: GraphView | null, incoming: GraphView) {
  const nodes = incoming.nodes.filter(node => !base?.nodes.some(item => item.id === node.id))
  const edges = incoming.edges.filter(edge => !base?.edges.some(item => item.id === edge.id))
  const snippets = (incoming.snippets ?? []).filter(
    snippet => !base?.snippets?.some(item => item.id === snippet.id)
  )
  const merged: GraphView = {
    ...(base ?? incoming),
    nodes: [...(base?.nodes ?? []), ...nodes],
    edges: [...(base?.edges ?? []), ...edges],
    view: {
      ...(base?.view ?? incoming.view),
      ...(incoming.view.expandedFaceIds?.length
        ? {
            expandedFaceIds: [
              ...new Set([...(base?.view.expandedFaceIds ?? []), ...incoming.view.expandedFaceIds]),
            ],
          }
        : {}),
    },
    snippets: [...(base?.snippets ?? []), ...snippets],
  }
  if (merged.snippets && merged.snippets.length > 50)
    throw new Error('An investigation supports up to 50 snippets.')
  return {
    view: merged,
    addedNodeIds: [...nodes.map(node => node.id), ...snippets.map(item => snippetNodeId(item.id))],
    addedEdgeIds: edges.map(edge => edge.id),
  }
}
